import type { ApiHttpClient } from "../interfaces/api-http-client";
import type { DeviceRegistration } from "./types";

export function createDeviceApi(http: ApiHttpClient) {
  return {
    async register(registration: DeviceRegistration) {
      return http.post<unknown>("/device/register", registration);
    },
    async deactivate(deviceId: string) {
      return http.post<unknown>("/device/deactivate", { deviceId });
    },
  };
}
